import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLicenseList } from "../../Body/api/redux";
import { Modal, Button, Input, notification } from "antd";
import { Tabs, Tab } from "@material-ui/core";
import * as Yup from "yup";
import { Formik } from "formik";
import jwt from "jwt-decode";
import { MenuItem, Menu } from "@material-ui/core";
import {
  loginAct,
  signInAct,
  selectauthList,
  setUser,
} from "../../Body/api/authRedux";
import config from "../../../config/config";

export default () => {
  const [open, setOpen] = useState(false);
  const [schema, setSchema] = React.useState({});
  const [authVals, setAuthVals] = React.useState({});
  const [menuOpen, setMenuOpen] = React.useState(false);

  const authValidationSchema = Yup.object().shape(schema);

  const signInSchema = {
    firstName: Yup.string().required("فیلد الزامی است"),
    lastName: Yup.string().required("فیلد الزامی است"),
    email: Yup.string().required("فیلد الزامی است"),
    nationalCode: Yup.string().required("فیلد الزامی است"),
  };

  const loginSchema = {
    userName: Yup.string().required("فیلد الزامی است"),
    password: Yup.string().required("فیلد الزامی است"),
  };
  const state = useSelector(selectauthList);


  React.useEffect(() => {
    const user = localStorage.getItem("userInfo");

    if (user) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let userData;
      if (userInfo.token) {
        userData = jwt(userInfo.token);
      }

      if (new Date(userInfo?.expire) > new Date() && userData) {
        dispatch(setUser(userData));
      } else {
        dispatch(setUser(undefined));
        localStorage.clear("userInfo");
      }
    }
  }, []);

  const dispatch = useDispatch();
  const handleTabsChange = (event, newValue) => {
    if (newValue === "login") {
      setSchema(loginSchema);
    } else if (newValue === "signin") {
      setSchema({ ...loginSchema, ...signInSchema });
    }
    setOpen({ ...open, type: newValue });
  };

  const handleMenuClose = () => {
    dispatch(setUser(undefined));
    localStorage.removeItem("userInfo");
    setMenuOpen(false);
  };

  const onClose = () => {
    setAuthVals({});
    setOpen({ ...open, open: false });
  };

  return (
    <>
      <div
        className="collapse navbar-collapse d-flex justify-content-end"
        id="navbarNav"
      >
        <ul className="navbar-nav gap-10">
          <li className="nav-item">
            {state.user ? (
              <>
                <h6
                  onClick={() => {
                    setMenuOpen(true);
                  }}
                >
                  {state?.user?.lastName} {state?.user?.firstName}
                </h6>
                <Menu
                  id="basic-menu"
                  open={menuOpen}
                  onClose={() => {
                    setMenuOpen(false);
                  }}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  className="texxxxxxxxxxxx"
                  PaperProps={{
                    className: "userInfo-menu",
                  }}
                >
                  <MenuItem onClick={handleMenuClose}>خروج</MenuItem>
                </Menu>
              </>
            ) : (
              <Button
                type="primary"
                className="btn-login"
                onClick={() => {
                  setOpen({ open: true, type: "login" });
                }}
              >
                ورود / ثبت نام
              </Button>
            )}
          </li>
          <a
            href={config.panelAdmin}
            target="_blank"
            className="nav-item"
          >
            <Button type="primary" className="btn-login">
              ثبت فرصت
            </Button>
          </a>
        </ul>
      </div>
      <Modal
        title=""
        className="as-modal"
        width={"60%"}
        onCancel={onClose}
        footer={false}
        visible={open?.open}
      >
        <Tabs
          TabIndicatorProps={{ style: { background: "#f7874a" } }}
          value={open?.type}
          onChange={handleTabsChange}
          className="w-100 d-flex justify-content-center"
        >
          <Tab
            label={
              <h6 className="my-auto" style={{ fontSize: "20px" }}>
                ورود
              </h6>
            }
            value="login"
            className="w-100 col-6"
          />
          <Tab
            label={
              <h6 className="my-auto" style={{ fontSize: "20px" }}>
                ثبت نام
              </h6>
            }
            value="signin"
            className="w-100 col-6"
          />
        </Tabs>
        <Formik
          enableReinitialize
          initialValues={authVals}
          validationSchema={authValidationSchema}
          validateOnChange={true}
          onSubmit={async (values) => {
            values.gender = 1;
            if (open?.type === "signin") {
              await dispatch(signInAct(values)).then((res) => {
                setOpen({ ...open, open: false });
                window.location.reload();
              });
            } else if (open?.type === "login") {
              await dispatch(loginAct(values)).then((res) => {
                setOpen({ ...open, open: false });
                window.location.reload();
              });
            }
          }}
        >
          {({ handleSubmit, values, setFieldValue, errors }) => {
            return (
              <>
                <div
                  className="container px-5"
                  style={{ paddingBlock: "25px" }}
                >
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{ gap: "30px" }}
                  >
                    <div className="d-flex flex-wrap w-100">
                      <h6
                        className="col-12 my-1rem text-right"
                        style={{ color: "#b10e1d" }}
                      >
                        {state.errMessage && state.errMessage}
                      </h6>
                      {open?.type === "signin" && (
                        <>
                          <div className="p-1 col-12 col-md-6 my-2-5">
                            <Input
                              value={values?.firstName}
                              className="authForms"
                              placeholder="نام"
                              onChange={(e) => {
                                setFieldValue("firstName", e.target.value);
                              }}
                            />
                            <h6 className="mb-0 mt-3 text-danger text-right">
                              {errors.firstName && errors.firstName}
                            </h6>
                          </div>
                          <div className="p-1 col-12 col-md-6 my-2-5">
                            <Input
                              value={values?.lastName}
                              className="authForms"
                              variant="outlined"
                              placeholder="نام خانوادگی"
                              onChange={(e) => {
                                setFieldValue("lastName", e.target.value);
                              }}
                            />
                            {errors.lastName && (
                              <h6 className="mb-0 mt-3 text-danger text-right text-danger">
                                {errors.lastName}
                              </h6>
                            )}
                          </div>
                          <div className="p-1 col-12 col-md-6 my-2-5">
                            <Input
                              value={values?.email}
                              className="authForms"
                              variant="outlined"
                              placeholder="ایمیل"
                              type="email"
                              onChange={(e) => {
                                setFieldValue("email", e.target.value);
                              }}
                            />
                            <h6 className="mb-0 mt-3 text-danger text-right">
                              {errors.email && errors.email}
                            </h6>
                          </div>
                          <div className="p-1 col-12 col-md-6 my-2-5">
                            <Input
                              value={values?.nationalCode}
                              className="authForms"
                              variant="outlined"
                              placeholder="کدملی"
                              onChange={(e) => {
                                setFieldValue("nationalCode", e.target.value);
                              }}
                            />
                            <h6 className="mb-0 mt-3 text-danger text-right">
                              {errors.nationalCode && errors.nationalCode}
                            </h6>
                          </div>
                        </>
                      )}
                      <div className="p-1 col-12 my-2-5">
                        <Input
                          value={values?.userName}
                          className="authForms"
                          variant="outlined"
                          placeholder="نام کاربری"
                          onChange={(e) => {
                            setFieldValue("userName", e.target.value);
                          }}
                        />
                        <h6 className="mb-0 mt-3 text-danger text-right">
                          {errors.userName && errors.userName}
                        </h6>
                      </div>
                      <div className="p-1 col-12 my-2-5">
                        <Input
                          value={values?.password}
                          className="authForms"
                          variant="outlined"
                          type="password"
                          placeholder="رمز ورود"
                          onChange={(e) => {
                            setFieldValue("password", e.target.value);
                          }}
                        />
                        <h6 className="mb-0 mt-3 text-danger text-right">
                          {errors?.password && errors?.password}
                        </h6>
                      </div>
                      <div className="col-12 p-1 my-2-5">
                        <Button
                          className="authButton col-12"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          <h6 className="my-auto">
                            {open?.type === "login" ? "ورود" : "ثبت نام"}
                          </h6>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};
